// Plain operation string (NOT a `*.gql.ts` file): the client's GraphQL codegen scans
// `./src/**/*.gql.ts` and validates operations against the wawi-service schema, which does not
// define `shared.recordUserEvent`. Keeping this as a `.mutation.ts` string excludes it from
// codegen so the build stays green while the call targets the console endpoint.
export const RECORD_USER_EVENT = /* GraphQL */ `
  mutation RecordUserEvent($input: RecordUserEventInput!) {
    shared {
      recordUserEvent(input: $input) {
        success
        errors {
          message
          type
        }
      }
    }
  }
`;
